import { Color } from './color';

import { AppCategoryOption, AppPropertiesAliasMap, LicenseTier } from '.';
import { LandingPageOptions } from '../shared/enums';
import { MapLayerEnum } from '../shared/enums/map-layer-type.enum';
import { File } from "./file";
import { User } from "./user";

/* istanbul ignore file */
export class App {
    activeLicenseTier: LicenseTier;
    activeSitesCount: number;
    aliases = new AppPropertiesAliasMap();
    chargeNumber = "";
    clientName: string;
    contact?: string;
    createdBy?: string;
    database: string;
    dateCreated: string;
    dateRequested: Date;
    fileContainers?: FileContainers;
    hasDefaultLayout: boolean;
    id: string;
    isActive = false;
    isApproved = false;
    landingPage: LandingPageOptions = LandingPageOptions.map;
    licenseExpirationDate: Date;
    mapLayerSelection?: MapLayerEnum;
    mapPin: File;
    mapPinColor?: Color;
    mapPinHeight: number;
    mapPinStyle?: number;
    mapPinWidth: number;
    name: string;
    pmName: string;
    primaryColor: Color;
    primaryContacts: PrimaryContact[];
    primaryLogo: File;
    primaryTextColor: PrimaryTextColor;
    processOnUpcomingInvoice = true;
    projects: any[];
    secondaryColor: Color;
    secondaryLogo: File;
    secondaryTextColor: Color;
    showDataImport = true;
    showDocumentTemplate = true;
    showDocumentTemplateOnSitePage = true;
    showInvoices = true;
    showProjectNotes = true;
    showReports = true;
    showSmartsheets = true;
    showLogicBuilder = true;
    showSiteMapVisibility = false;
    showDashboard = true;
    showSiteTemplates = false;
    showSummaryProject = false;
    url: string;
    userId: string;
    users: User[];
    isAutoRenewEnabled?: boolean;
    useCase?: AppCategoryOption;
    discipline?: AppCategoryOption;
    subCategory?: AppCategoryOption;
}

export class PrimaryContact {
    email: string;
    id: string;
    name: string;
}

export class FileContainers {
    private: Private;
    public: Public;
}

export class Public {
    name: string;
    uri: string;
}

export class Private {
    name: string;
    uri: string;
}

export class PrimaryTextColor {
    r: number;
    g: number;
    b: number;
    a: number;
    hex: string;
    rgba: string;
    roundA: number;
}
